<template>
  <div>
    <h4 class="header-sub">
      {{ $t("menu.data_table") }}
      <b-btn
        v-b-toggle.map-control-tips
        class="btn-collapse-tips"
        variant="outline-warning"
        >{{ $t("menu.show") }}</b-btn
      >
    </h4>
    <!-- 地圖操作提示 -->
    <div class="collapse-tips-area">
      <b-collapse visible id="map-control-tips">
        <b-card>
          <div class="device" v-if="sensorParams.length > 0">
            <div class="block-area">
              Sensor Params：
              <div
                v-if="deviceType == 'gateway' || deviceType == 'accesspoint'"
                class="device-sensor"
              >
                <div
                  v-for="(ds, idx_ds) in sensorParams"
                  :key="idx_ds"
                  class="device-sensor-blocks"
                >
                  {{ ds }}
                </div>
              </div>
              <div v-else class="device-sensor">
                <div
                  v-for="(ds, idx_ds) in sensorParams"
                  :key="idx_ds"
                  class="device-sensor-blocks"
                >
                  {{ $t("sensor." + ds) }}
                  <div class="device-unit" v-html="$t('sensor.u_' + ds)"></div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="deviceData.time.length > 0">
            <div class="list-table-result scroll-style-gray">
              <b-table
                hover
                small
                dark
                responsive
                :fields="table_fields"
                :items="table_items"
                :current-page="currentPage"
                :per-page="perPage"
              >
                <!-- A virtual column -->
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
              </b-table>

              <b-row v-if="perPage">
                <b-col md="6" class="my-1">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="table_items.length"
                    :per-page="perPage"
                    class="my-0"
                  ></b-pagination>
                </b-col>
              </b-row>
            </div>
          </div>
          <div v-else>
            <NoData></NoData>
          </div>
        </b-card>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import NoData from "@/views/components/NoData";
import { dragscroll } from "vue-dragscroll"; // 滑鼠可拖拉 scroll 區域

export default {
  props: {
    deviceData: {
      type: Object,
      required: true,
    },
    deviceType: {
      type: String,
      default: "device",
    },
    sensorParams: {
      type: Array,
      default: [],
    },
    paramsSortable: {
      type: Boolean,
      default: false,
    },
    perPage: {
      type: Number,
      default: undefined,
    },
  },
  directives: {
    dragscroll: dragscroll,
  },
  components: {
    NoData,
  },
  data() {
    return {
      table_fields: [],
      table_items: [],
      currentPage: 1,
    };
  },
  mounted() {
    this.arrangeData();
  },
  watch: {
    deviceData() {
      this.arrangeData();
    },
  },
  methods: {
    arrangeData() {
      this.table_fields = [
        { key: "idx", sortable: true },
        { key: "time", sortable: true },
      ];
      this.table_items = [];

      for (let i = 0; i < this.deviceData.time.length; i++) {
        let _data = {};

        Object.keys(this.deviceData).forEach((_key) => {
          let _key_title = _key;

          // 強制讓 time 是第一個
          if (_key == "time") {
            _data["idx"] = i + 1;
          } else {
            // if ( this.$t('sensor.u_' + _key) )  _key_title = _key + ' ( ' + this.$t('sensor.u_' + _key) + ' )'

            this.table_fields.push({
              key: _key_title,
              sortable: this.paramsSortable,
            });
          }
          _data[_key_title] = this.deviceData[_key][i];
        });

        this.table_items.push(_data);
      }
      this.table_items.reverse();
    },
  },
};
</script>

<style lang="scss" scoped>
.list-table-result {
  max-height: 500px;
  overflow-y: auto;
}
</style>
